import React from "react";

function ServiceCard(props) {
  return (
    <>
      <div className={`service-card-premium ${props.layoutClass || ''} ${props.video ? 'has-video' : ''}`}>
        <div className="card-top-accent"></div>

        <div className="service-card-inner">
          <div className="service-header">
            <div className="service-icon-box">
              <img src={`${process.env.PUBLIC_URL}${props.image}`} alt={props.title} />
            </div>
            <div className="service-number-badge">{props.serviceNumber}</div>
            {props.video && (
              <div className="live-status-badge">
                <span className="dot"></span>
                LIVE
              </div>
            )}
          </div>
          
          <div className="service-body">
            <h4>{props.title}</h4>
            <p>{props.details}</p>
          </div>
        </div>

        {props.video && (
          <div className="service-video-container">
            <video
              src={props.video}
              muted
              loop
              playsInline
              autoPlay
            />
            <div className="video-glass-overlay"></div>
          </div>
        )}
      </div>
    </>
  );
}

export default ServiceCard;
